import { createSelector } from '@ngrx/store';

import { selectCropFieldsState } from './bba-cancellation.feature';

export const selectCropFields = createSelector(selectCropFieldsState, (cropFieldsState) => cropFieldsState.data);

export const selectCancellableAdviceIdsByCustomerIds = createSelector(selectCropFields, (cropFields) =>
  cropFields
    .filter(({ isCancelled, cancellationDate }) => isCancelled && cancellationDate == null)
    .reduce(
      (dictionary, cropField) => {
        if (cropField.adviceId && cropField.customerId) {
          dictionary[cropField.adviceId] = cropField.customerId;
        }
        return dictionary;
      },
      {} as Record<number, number>,
    ),
);

export const hasCancellableCropFields = createSelector(selectCropFields, (cropFields) =>
  cropFields.some(({ isCancelled, cancellationDate }) => isCancelled && cancellationDate == null),
);

export const selectIsCropFieldsLoading = createSelector(selectCropFieldsState, (cropFieldsState) => cropFieldsState.isLoading);

export const isCropFieldsError = createSelector(selectCropFieldsState, (cropFieldsState) => cropFieldsState.isError);

export const selectCropFieldsFilter = createSelector(selectCropFieldsState, (cropFieldsState) => cropFieldsState.filter);

export const selectCropFieldsPagination = createSelector(selectCropFieldsState, (cropFieldsState) => cropFieldsState.pagination);

export const selectCropYear = createSelector(selectCropFieldsFilter, (filter) => filter.cropYear);

export const selectStatusFilter = createSelector(selectCropFieldsFilter, (filter) => filter.statusFilter);

export const selectSearchTermFilter = createSelector(selectCropFieldsFilter, (filter) => filter.searchTerm ?? '');

export const selectCustomerNameFilter = createSelector(selectCropFieldsFilter, (filter) => filter.customerName ?? '');

export const selectCropFieldNameFilter = createSelector(selectCropFieldsFilter, (filter) => filter.cropFieldName ?? '');

export const selectTotalCropFieldsAmount = createSelector(selectCropFieldsState, (cropFieldsState) => cropFieldsState.pagination.totalItemCount);

export const selectPageSize = createSelector(selectCropFieldsPagination, (pagination) => pagination.pageSize);

export const selectPageNumber = createSelector(selectCropFieldsPagination, (pagination) => pagination.pageNumber);
